/**
 * Dev/test JWT fallback: REACT_APP_DEV_JWT, or sessionStorage key `churnsignal_dev_jwt`.
 * Jest uses MOCK_AUTH_EMAIL_KEY + the Amplify mock so axios gets a Bearer token from Auth.currentSession().
 */
export const MOCK_AUTH_EMAIL_KEY = 'auth-mock-email';
const DEV_LOGGED_OUT_KEY = 'churnsignal_dev_logged_out';
const DEV_JWT_STORAGE_KEY = 'churnsignal_dev_jwt';

export function isDevAuthLoggedOut(): boolean {
  try {
    return sessionStorage.getItem(DEV_LOGGED_OUT_KEY) === '1';
  } catch {
    return false;
  }
}

/** After explicit sign-out, ignore REACT_APP_DEV_JWT until the user signs in again. */
export function markDevAuthLoggedOut(): void {
  try {
    sessionStorage.setItem(DEV_LOGGED_OUT_KEY, '1');
    sessionStorage.removeItem(DEV_JWT_STORAGE_KEY);
    sessionStorage.removeItem('workspace');
    sessionStorage.removeItem('sideBarState');
  } catch {
    /* ignore */
  }
}

export function clearDevAuthLoggedOut(): void {
  try {
    sessionStorage.removeItem(DEV_LOGGED_OUT_KEY);
  } catch {
    /* ignore */
  }
}

export function getMockBearerToken(): string {
  if (isDevAuthLoggedOut()) {
    return '';
  }

  // Do not guard with `typeof process` — CRA/webpack inlines `process.env.*` at build time,
  // but `process` is undefined in the browser, so a guard would skip the inlined JWT entirely.
  const fromEnv = process.env.REACT_APP_DEV_JWT || '';
  if (String(fromEnv).trim()) {
    return String(fromEnv).trim();
  }
  try {
    if (typeof sessionStorage !== 'undefined') {
      const manual = sessionStorage.getItem(DEV_JWT_STORAGE_KEY);
      if (manual && String(manual).trim()) {
        return String(manual).trim();
      }
    }
  } catch {
    /* ignore */
  }
  return '';
}
